export enum DeliveryStatus {
    Available = 'DELIVERY_STATUS_AVAILABLE',
    AvailableNoDeliveryDate = 'DELIVERY_STATUS_AVAILABLE_NO_DELIVERY_DATE',
    Tracked = 'DELIVERY_STATUS_TRACKED',
    Unavailable = 'DELIVERY_STATUS_NOT_AVAILABLE',
    OnRequest = 'DELIVERY_STATUS_ON_REQUEST',
}

const translationObject: { [Key in DeliveryStatus]: string } = {
    [DeliveryStatus.Available]: 'app.product.detail.deliveryOption.available',
    [DeliveryStatus.AvailableNoDeliveryDate]: 'app.product.detail.deliveryOption.availableNoDeliveryDate',
    [DeliveryStatus.Tracked]: 'app.product.detail.deliveryOption.tracked',
    [DeliveryStatus.Unavailable]: 'app.product.detail.deliveryOption.unavailable',
    [DeliveryStatus.OnRequest]: 'app.product.detail.deliveryOption.onRequest',
};

export const getDeliveryStatusTranslationId = (deliveryStatus: DeliveryStatus): string => {
    return translationObject[deliveryStatus];
};
